import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CtrlTooltipComponent, CtrlTooltipDirective } from '@co-3/ctrl-ui/tooltips';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-info-tooltip',
    imports: [CtrlTooltipComponent, CtrlTooltipDirective],
    templateUrl: './info-tooltip.component.html',
    styleUrl: './info-tooltip.component.scss',
})
export class InfoTooltipComponent {
    public heading = input<string | undefined>();
    public text = input.required<string>();
}
